import { ResponsiveContainer } from "recharts";

const containerDimension = value =>
  typeof value === "string" && value.includes("%")
    ? `calc(${value} / var(--mg-display-scale, 1))`
    : typeof value === "number" ? `${value}px` : value;

export default function DensityResponsiveContainer({ width = "100%", height = "100%", style, className = "", ...props }) {
  return (
    <ResponsiveContainer
      {...props}
      width={width}
      height={height}
      className={`mg-density-chart ${className}`}
      style={{ ...style, "--mg-chart-width": containerDimension(width), "--mg-chart-height": containerDimension(height) }}
    />
  );
}
